module.exports = __webpack_public_path__ + "img/bny-detail-3.d0c55c48.png";